<template>
    <div
        class="voice"
        :class="{ playable }"
        v-bind="$attrs"
        @click="voicePlay()"
    >
        <!-- Audio resource -->
        <audio preload="metadata">
            <source
                v-if="urlMp3"
                :src="urlMp3"
                type="audio/mpeg"
            >
            <source
                v-if="urlOgg"
                :src="urlOgg"
                type="audio/ogg"
            >
        </audio>

        <!-- Voice icon -->
        <span class="voice-icon">
            <!-- Loading -->
            <template v-if="voiceStatus === 'loading'">
                <span class="spinner"/>
            </template>

            <!-- Play -->
            <template v-else>
                <i class="icon-voice me-1"/>
            </template>
        </span>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'VoiceMin',
    props: {
        type: {
            type: String,
            default: '',
        },
        name: {
            type: String,
            default: '',
        },
        append: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            urlMp3: null,
            urlOgg: null,
            filename: this.name,
            voiceStatus: null,
            lessonNum: window.location.pathname.split('/').pop()
        }
    },
    computed: {
        ...mapGetters('lessonsModule', [
            'allRecordings'
        ]),

        // Get the shortened path (namespace) to the audio
        audioNamespace() {
            return (this.type === 'lesson_related') ? `${this.type}/${this.lessonNum}` : this.type
        },

        // Check if the audio is playable
        playable() {
            if (this.allRecordings && this.audioNamespace) {
                return this.allRecordings[`${this.audioNamespace}/${this.filename}`]
            }
            return false
        }
    },
    watch: {
        // When got all audio recording paths
        allRecordings() {
            // For development: If the current audio is not playable, check if it exists in another folder
            if (
                process.env.NODE_ENV === 'development'
                && this.allRecordings
                && this.audioNamespace
                && this.filename
                && !this.playable
            ) {
                let ns1 = `lesson_related/${this.lessonNum}`,
                    ns2 = `vocabulary`,
                    ns3 = `letter`,
                    resultNs
                if (this.allRecordings[`${ns1}/${this.filename}`]) {
                    resultNs = ns1
                } else if (this.allRecordings[`${ns2}/${this.filename}`]) {
                    resultNs = ns2
                } else if (this.allRecordings[`${ns3}/${this.filename}`]) {
                    resultNs = ns3
                }
                if (resultNs) {
                    setTimeout(() => {
                        console.log(`Найдена аудиозапись в другой папке: ${this.filename} -- не ${this.audioNamespace}, а ${resultNs}`)
                    }, 1500)
                }
            }
        },
    },
    mounted() {
        this.fetchAllRecordings()
        let audioElement = $(this.$el).find('audio')[0], loadingTimeout

        // Sync the voice status to 'loading' (with a small delay for the smooth user experience)
        audioElement.onplay = () => {
            loadingTimeout = setTimeout(() => {
                this.voiceStatus = 'loading'
                $(this.$el).addClass('loading')
            }, 300)
        }

        // Sync the voice status to 'playing'
        audioElement.onplaying = () => {
            clearTimeout(loadingTimeout)
            this.voiceStatus = 'playing'
            $('.voice.ended').removeClass('ended')
            $(this.$el).removeClass('loading').addClass('playing')
        }

        // Remove the status classes and reset the player time
        audioElement.onpause = () => {
            clearTimeout(loadingTimeout)
            this.voiceStatus = 'ended'
            $(this.$el).removeClass('loading playing')
            audioElement.currentTime = 0
        }
    },
    methods: {
        ...mapActions('lessonsModule', [
            'fetchAllRecordings'
        ]),

        // Build url based on namespace and other parameters
        buildUrl() {
            this.urlMp3 =
                `/audio/mp3/`// main audio folder
                + `${this.audioNamespace}/` // namespace of the audio
                + this.name.substring(0, 40) // name
                + (this.append ? '_' + this.append : '') // addition to name
                + '.mp3' // extension

            this.urlOgg =
                `/audio/ogg/`// main audio folder
                + `${this.audioNamespace}/` // namespace of the audio
                + this.name.substring(0, 40) // name
                + (this.append ? '_' + this.append : '') // addition to name
                + '.ogg' // extension
        },

        // Load and play the audio
        voicePlay() {
            if ($(this.$el).hasClass('playable')) {
                let audioElement = $(this.$el).find('audio')[0]

                // Build url if it doesn't exist
                if (!this.urlMp3) {
                    this.buildUrl()
                    audioElement.load()
                }

                // Stop all audios and reset progress bars.
                // Notice: due to the loading delay, in case of quick launches, the other audio will not have any of
                // these classes at this point, so the quick launches will overlap each other
                $('.voice.loading, .voice.playing, .voice.ended').each(function () {
                    $(this).find('audio')[0]?.pause()
                    // Remove the green background, because the audio was paused not due to its end reaching
                    $(this).removeClass('ended').css('background-size', '')
                })

                // Play the current audio
                audioElement.play().catch((e) => {
                    console.log(e)
                })
            }
        },
    },
}
</script>

<style scoped lang="scss">
.voice {
    display: inline-block;
    color: #000a;
    transition: color .15s ease;
    &:hover {
        color: #000;
    }
    i {
        display: none;
    }
    .voice-content {
        display: inline-block;
    }
    &.playable {
        padding: 0 5px 3px;
        border: none;
        border-radius: 8px;
        background: none;
        cursor: pointer;
        .voice-icon {
            color: inherit;
            i {
                display: inline;
                font-size: .9rem;
            }
        }
    }
}
</style>
